import { useEffect, useState } from 'react';
import type { SocialProviderName } from '@redpandev/shared';
import { api } from '../../lib/api';

/**
 * Sonde les providers sociaux ACTIFS (`GET /auth/providers`, spec 11 §13) AU
 * MONTAGE — patron `useEmailFeature`. Feature dark (flags off) → liste vide →
 * aucun bouton social rendu, prod intacte. Cache module : une seule sonde par
 * session, partagée entre /login et /signup. Un hoquet réseau → liste vide (on
 * ne mémorise pas : la connexion classique reste toujours disponible).
 */
let cached: SocialProviderName[] | null = null;
let inflight: Promise<SocialProviderName[]> | null = null;

function probe(): Promise<SocialProviderName[]> {
  if (cached !== null) return Promise.resolve(cached);
  inflight ??= api
    .getSocialProviders()
    .then((res) => (cached = res.providers))
    .catch(() => [] as SocialProviderName[]) // pas de bouton plutôt qu'un bouton mort
    .finally(() => {
      inflight = null;
    });
  return inflight;
}

export function useSocialProviders(): SocialProviderName[] {
  const [providers, setProviders] = useState<SocialProviderName[]>(cached ?? []);

  useEffect(() => {
    let alive = true;
    if (cached === null) {
      void probe().then((p) => alive && setProviders(p));
    }
    return () => {
      alive = false;
    };
  }, []);

  return providers;
}

/** Réinitialise le cache module (tests). */
export function resetSocialProvidersCache(): void {
  cached = null;
  inflight = null;
}
